import React from 'react';
import './Tooltip.css';

interface Props {
  children: React.ReactNode;
}

const Tooltip = ({ children }: Props) => {
  return <div className="Tooltip">{children}</div>;
};

export default Tooltip;
